import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonAtcViewModel } from 'src/app/model/common/atc.view';
import { CommonAtcService } from './common.atc.service';

@Component({
  selector: '[ms-common-atc-table]',
  templateUrl: './common.atc-table.component.html',
})
export class CommonAtcTableComponent
  extends BaseComponent
  implements AfterViewInit
{
  @ViewChild('dt') dt?: Table;
  @Output() atcTable: EventEmitter<Table> = new EventEmitter();
  @Input() isCounter = false;
  @Input() isDoctor = false;

  protected setScreen = false;
  atcPaged: VonPageResponseModel<CommonAtcViewModel> =
    {} as VonPageResponseModel<CommonAtcViewModel>;
  dtIdFilter = '';
  dtNameFilter = '';

  constructor(protected service: CommonAtcService) {
    super();
  }

  ngAfterViewInit() {
    this.atcTable.emit(this.dt);
  }

  onInit = () => {
    this.loading = true;
    this.subscriptions.push(
      this.service.getLazyLoad().subscribe((atc) => (this.atcPaged = atc))
    );
  };

  lazyRead = ($event: LazyLoadEvent) => {
    this.service.setLoadingState();
    const page = $event.first! / $event.rows!;
    const query = $event.filters?.name ? $event.filters.name.value : '';
    this.subscriptions.push(
      this.service.readPaged(page, $event.rows!, query).subscribe()
    );
  };
}
